// extracted by mini-css-extract-plugin
module.exports = {"card":"I_jGJfqh","topic":"GxIaJRdv","favour":"DmHNAgth","active":"eLpgatue","img":"thnvxKTT","name":"UZ2n6I_I"};